import React from 'react';
import BrandLogo from 'flow/components/nav/BrandLogo';

const RetailerLogoCentralSwitchWidget = () => {
    return <BrandLogo type="logo60" />;
};

export default RetailerLogoCentralSwitchWidget;
